import type { GetDiagnosisDaoUrlsResponse } from '@/infra/api/generated/model'
import { getDiagnoses } from '@/infra/api/generated/diagnoses/diagnoses'

const { getDiagnosisDaoUrls } = getDiagnoses()

export const fetchDaoUrlsForQuestion = async (
  diagnosisId: string
): Promise<GetDiagnosisDaoUrlsResponse> => {
  return getDiagnosisDaoUrls(diagnosisId)
}
